import { isPresent } from '@jjvgaming/player-payback-library'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type ApiError } from 'openapi-typescript-fetch'
import {
  type UpdateLicensedEstablishmentUserRequest,
  type FullLicensedEstablishmentUserDTO,
} from 'src/types/api'

interface UsePutLicensedEstablishmentUserParams {
  licensedEstablishmentUserId: number
  licensedEstablishmentId?: number | null
  corporateAccountId?: number | null
  organizationId?: number | null
  onSuccess?: (data: FullLicensedEstablishmentUserDTO) => Promise<void>
  onError?: (error: ApiError) => Promise<void>
}

export const usePutLicensedEstablishmentUser = ({
  licensedEstablishmentUserId,
  licensedEstablishmentId,
  corporateAccountId,
  organizationId,
  onSuccess,
  onError,
}: UsePutLicensedEstablishmentUserParams) => {
  const queryClient = useQueryClient()
  const put = useTypedApiClient({
    path: '/le-connect/licensed-establishments/users/{id}',
    method: 'put',
  })

  return useMutation({
    mutationFn: async (
      licensedEstablishmentUser: UpdateLicensedEstablishmentUserRequest
    ) => {
      const { data } = await put({
        ...licensedEstablishmentUser,
        licensedEstablishmentId,
        corporateAccountId,
        organizationId,
        id: licensedEstablishmentUserId,
      })
      return { data }
    },
    onSuccess: async ({ data }) => {
      await queryClient.invalidateQueries({
        queryKey: [
          '/le-connect/licensed-establishments/users/{id}',
          licensedEstablishmentUserId,
        ],
      })
      if (isPresent(onSuccess)) {
        await onSuccess(data)
      }
    },
    onError,
  })
}
